import React from 'react';
import Anchor from '@sdtech/sd-ui/Anchor';

function ErrorFragment() {
  return (
    <div>
      <h3 className="u-clr-white">Cookies Required</h3>
      <p className="u-padding-m-top">Cookies required for authentication weren&apos;t found.</p>
      <br />
      <p>
        {' '}
        Please ensure that your web browser supports Cookies for functionality and
        authentication.
      </p>
      <br />
      <p>
        {' '}
        If you are using Safari version 13 or older, please upgrade to a more recent
        version. If that doesn’t solve the
        problem,
        {' '}
        <Anchor href="https://service.elsevier.com/app/contact/supporthub/sciencedirect/" className="u-clr-orange">our support team </Anchor>
        {' '}
        will be happy to help.
      </p>
    </div>
  );
}

export default ErrorFragment;
